import graphqlClient from "../../../apollo";

class RegistroActividadProvider {
  entities() {
    return graphqlClient.query({
      query: require("./gql/registroActividadEntities.graphql"),
      fetchPolicy: "network-only",
    });
  }

  find(id) {
    return graphqlClient.query({
      query: require("./gql/registroActividadFind.graphql"),
      variables: { id },
      fetchPolicy: "network-only",
    });
  }

  paginate(
    pageNumber,
    itemsPerPage,
    search = null,
    filters = null,
    orderBy = "createdAt",
    orderDesc = true,
    fechaDesde = null,
    fechaHasta = null
  ) {
    return graphqlClient.query({
      query: require("./gql/registroActividadPaginate.graphql"),
      variables: {
        pageNumber,
        itemsPerPage,
        search,
        filters,
        orderBy,
        orderDesc,
        fechaDesde,
        fechaHasta,
      },
      fetchPolicy: "network-only",
    });
  }
}

export default new RegistroActividadProvider();
